<template>
  <NewsCategoryBase
    :title="{ 'zh-CN': '本站动态', 'en-US': 'Company News' }"
    route-path="/news/company"
    category="company"
  />
</template>
<script>
import NewsCategoryBase from "./NewsCategoryBase.vue";
export default { name: "CompanyNewsPage", components: { NewsCategoryBase } };
</script>
